var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "component-header" }, [
    _c("div", {
      staticClass: "btn-back",
      on: {
        click: function ($event) {
          return _vm.goBack()
        },
      },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
    _vm._v(" "),
    _c("div", {
      staticClass: "icon-user",
      on: {
        click: function ($event) {
          return _vm.$router.push("/personcenter")
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }